import { reviewFormDataDbWriteValidator } from "@redotech/redo-model/form-builder-form/db-validator/review/review-form-builder-form-db-validator";
import * as z from "zod";

export const createReviewForm = {
  name: "createReviewForm" as const,
  input: z.object({
    teamId: z.string(),
    formData: reviewFormDataDbWriteValidator,
  }),
  output: z.null(),
};
